import { useState } from 'react';
import { Pencil, Plus, Trash2 } from 'lucide-react';
import type { ColumnDef } from '@tanstack/react-table';

import { FloorplanEditor } from "./FloorplanEditor";

import { Button } from "@/components/ui/button";
import { DataTable } from "@/components/ui/data-table";
import { Input } from "@/components/ui/input";

const initialSpaces = [{ name: '1.01', area: 0, shape: [] }, { name: '1.02', area: 0, shape: [] }];
const initialAssets = [{ name: 'Kälteanlage X42', point: { x: 150, y: 400 } }, { name: 'Sprinkler 16.1.22', point: { x: 350, y: 280 } }];

export function EditorTest(_props: any) {
    const [spaces, setSpaces] = useState(initialSpaces) as any;
    const [assets, _setAssets] = useState(initialAssets) as any;
    const [selectedSpaceIndex, setSelectedSpaceIndex] = useState() as any;

    const spacesColumns: ColumnDef<any>[] = [{
        id: 'actions',
        header: '',
        size: 100,
        enableSorting: false,
        cell: ({ row }) => (
            <div className='flex items-center gap-1'>
                <Button type="button" variant="ghost" size="icon" aria-label="Raum löschen" onClick={() => {
                    setSelectedSpaceIndex(spaces.indexOf(row.original));
                }}><Trash2 aria-hidden="true" className="h-4 w-4" /></Button>
                <Button type="button" variant="ghost" size="icon" aria-label="Raum bearbeiten" onClick={() => {
                    setSelectedSpaceIndex(spaces.indexOf(row.original));
                }}><Pencil aria-hidden="true" className="h-4 w-4" /></Button>
            </div>
        ),
    }, {
        id: 'name',
        header: 'Name',
        cell: ({ row }) => (
            <Input value={row.original.name} readOnly className="w-[250px]" aria-label="Name" />
        ),
    }, {
        id: 'area',
        header: 'Fläche/㎡',
        cell: ({ row }) => (
            <span className="block text-right">{row.original.shape ? row.original.area : '-'}</span>
        ),
    }];

    return <div className="flex gap-4">
        <div className="min-w-0 flex-1">
            <FloorplanEditor floor={{spaces: spaces}} assets={assets}
                selectedSpaceIndex={selectedSpaceIndex}></FloorplanEditor>
        </div>
        <div>
            <div className='mt-4 text-lg font-semibold'>Räume</div>
            <Button type="button" variant="ghost" className='mt-4'
                onClick={() => {
                    setSpaces([...spaces, { name: 'New Space', shape: [] }]);
                    setSelectedSpaceIndex(spaces.length);
                }}>
                <Plus aria-hidden="true" className="h-4 w-4" />
                Raum anlegen
            </Button>
            <DataTable
                data={spaces}
                columns={spacesColumns}
                pageSize={5}
            />
        </div>
    </div>
}
